<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="B2B Provider Configuration"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <b-card>
        <b-row>
          <!-- <b-col md="4" v-for="(gateway, index) in b2bGatewayList" :key="index">
            <b-card
              style="
                border-radius: 10px;
                box-shadow: 0 0 10px 2px rgb(154 161 171 / 15%);
              "
            >
              <div
                style="width: 150px; height: 70px; margin: auto; display: block"
              >
                <b-card-img
                  class="card-img-top"
                  :src="gateway.logo"
                  :alt="`${gateway.name} Gateway`"
                />
              </div>
              <div>
                <h4 class="text-capitalize">{{ gateway.name }}</h4>
                <p class="description">
                  {{ gateway.description }} Lorem ipsum dolor sit amet
                  consectetur, adipisicing elit. Voluptates repellendus harum
                  corporis magnam velit, consequuntur incidunt nemo veritatis
                  fuga quos natus commodi iste eum quae doloribus quisquam
                  omnis, et dolores?
                </p>
              </div>
              <b-card-footer class="pt-3" style="text-align: center">
                <button
                  v-if="
                    b2bConfiguredGatewayList[gateway.key] ||
                    b2bConfiguredGatewayList.recharge[gateway.key]
                  "
                  type="button"
                  :id="`gateway-configure-${index}`"
                  style="border-radius: 7px"
                  class="btn btn-success"
                >
                  Configured
                </button>
                <button
                  v-else
                  type="button"
                  id="gateway-configure"
                  style="border-radius: 7px"
                  class="btn btn-primary"
                  @click="onClickConfigure(gateway)"
                >
                  Configure
                </button>
              </b-card-footer>
            </b-card>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col md="4" v-for="(gateway, index) in b2bGatewayList" :key="index"
            ><configCard
              :imgSrc="gateway.logo"
              :name="gateway.name"
              :detailsText="gateway.description"
              :isConfigured="
                b2bConfiguredGatewayList[gateway.key] ||
                b2bConfiguredGatewayList.recharge[gateway.key]
                  ? true
                  : false
              "
              :showSwitch="false"
              :showSetting="false"
              @onClickConfigure="onClickConfigure(gateway)"
            ></configCard
          ></b-col>
        </b-row>
        <template>
          <b-modal
            hide-header
            id="thirdparty-gateway-config"
            size="md"
            ref="gateway-config"
            centered
            hide-footer
          >
            <h4 class="text-capitalize pb-3">{{ gatewayInfo.name }}</h4>
            <!-- <b-row>
              <b-col md="6">
                <eb-select
                  type="select"
                  :options="marketList"
                  label="text"
                  id="SelectMarket"
                  placeholder="Select Market"
                  class="mt-0 currencyNameDropdown mb-0"
                  v-model="selectMarket"
                  :selected="selectMarket"
                  @input="onSelectCode(selectMarket)"
                ></eb-select>
              </b-col>
            </b-row> -->
            <b-row>
              <b-col md="6">
                <b-form-input
                  maxlength="500"
                  type="text"
                  placeholder="Username"
                  v-model="username"
                ></b-form-input>
              </b-col>
              <b-col md="6">
                <b-form-input
                  maxlength="500"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col v-if="gatewayInfo.name == 'healthians'">
                <b-form-input
                  maxlength="500"
                  placeholder="Checksum Key"
                  v-model="merchantId"
                ></b-form-input>
              </b-col>
              <b-col v-else>
                <b-form-input
                  maxlength="500"
                  placeholder="Authentication Key"
                  v-model="merchantId"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="justify-content-md-center mt-3">
              <b-col md="4">
                <b-button variant="outline-primary" block @click="hideModal"
                  >Cancel</b-button
                >
              </b-col>
              <b-col md="4">
                <b-button
                  variant="primary"
                  block
                  @click="onClickSaveConfig(gatewayInfo)"
                  >Save</b-button
                >
              </b-col>
            </b-row>
          </b-modal>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
// import ebSelect from "@/components/FormElements/Select.vue";
import profile from "@/components/profile/profileCategory";
import configCard from "@/components/tenantConfig/configCard.vue";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    configCard,
    ComponentHeader,
    // ebSelect,
  },
  data() {
    return {
      gatewayInfo: {},
      merchantId: "",
      username: "",
      password: "",
      configuredGateway: [],
      unconfiguredGateway: [],
      //   selectMarket: {
      //     value: "market1",
      //     text: "Market",
      //   },
      //   marketList: [
      //     {
      //       value: "market1",
      //       text: "Market",
      //     },
      //     {
      //       value: "market2",
      //       text: "Grocery",
      //     },
      //   ],
    };
  },
  computed: {
    ...mapState({
      b2bGatewayList: (state) => state.tenant.b2bGatewayList,
      b2bConfiguredGatewayList: (state) => state.tenant.b2bConfiguredGateway,
    }),
  },
  methods: {
    onClickConfigure(gatewayData) {
      this.gatewayInfo = gatewayData;
      this.$refs["gateway-config"].show();
    },
    hideModal() {
      this.$refs["gateway-config"].hide();
    },
    async onClickSaveConfig(gatewayInfo) {
      let payload = {};
      if (gatewayInfo?.name == "mobikwik") {
        payload = {
          recharge: {
            mobikwik: {
              uid: this.username,
              pwd: this.password,
              key: this.merchantId,
            },
          },
        };
      }
      if (gatewayInfo.name == "healthians") {
        payload = {
          Healthians: {
            username: this.username,
            password: this.password,
            checksumkey: this.merchantId,
          },
        };
      }
      if (this.username && this.password && this.merchantId) {
        await this.$store
          .dispatch("tenant/getB2bGatewayConfigure", payload)
          .then((result) => {
            this.$swal({
              title: "Success!",
              text: "B2B Provider Configured Successfully.",
              type: "success",
            }).then(async (result) => {
              let payload = {};
              await this.$store.dispatch(
                "tenant/getB2bConfiguredGateway",
                payload
              );
              this.hideModal();
            });
            (this.merchantId = ""), (this.username = ""), (this.password = "");
          })
          .catch((error) => {
            this.$toasted.error(error.message);
          });
      } else {
        this.$swal({
          title: "Error!",
          text: "All Fields Required!",
          type: "error",
        });
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("tenant/getB2bGatewayList");
    let payload = {};
    await this.$store.dispatch("tenant/getB2bConfiguredGateway", payload);
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style scoped>
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}
.card-body {
  padding: 15px;
}
.card-footer {
  border-top: 2px dashed #c8d1d7;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
.description {
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  min-height: 6rem;
  -webkit-box-orient: vertical;
}
</style>
